/**
 * This guard checks the url on each navigation and sets the corresponding navigation item as active.
 * Since we are not making a full page reload we can not use the php render function to set the active item.
 *
 * @param to
 * @param from
 * @param next
 */
export default function (to, from, next) {
  var elements = document.getElementsByClassName('navigationElement')
  Array.prototype.forEach.call(elements, el => {
    el.classList.remove('active')
  })

  var selector = '/shop'
  if (to.name === 'cart/index') {
    selector = '/shop#/cart'
  }

  elements = document.getElementsByClassName('navigationElement shop')
  Array.prototype.forEach.call(elements, el => {
    let node = el.querySelectorAll(`[href="${selector}"], [page_id="module_shop"]`)
    if (node.length) {
      node[0].parentNode.classList.add('active')
    }
  })

  // in mobile view we need to close the navigation, because we do not always make a full page reload
  let mobileMenu = document.getElementsByClassName('wsc_navigation_close')
  if (mobileMenu.length) {
    mobileMenu[0].click()
  }

  // add a class to body
  document.body.classList.add('module-shop-active')

  next()
}



// WEBPACK FOOTER //
// ./client/router/guards/beforeEach.js